module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-898896.svg";


/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
 ** module id = 913
 ** module chunks = 2
 **/